// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBq3DOBq5oXgbdQ5qVHsxLRgdD0ZaWlU08",
  authDomain: "iot1-1cfbf.firebaseapp.com",
  projectId: "iot1-1cfbf",
  storageBucket: "iot1-1cfbf.appspot.com",
  messagingSenderId: "242868141937",
  appId: "1:242868141937:web:5215e8337387e3340140d0",
};

// Initialize Firebase
//const app = initializeApp(firebaseConfig);
initializeApp(firebaseConfig); //inicializar directamente
